import { PartialBy } from '../../types'
import { ToolbarButton } from './toolbar-button'
import { ToolbarGroup, ToolbarGroupProps } from './toolbar-group'

export function ToolbarItem({
  defaultItem,
  isActive,
  isInAction,
  groupItems,
  groupTitle,
  onChange,
  disabled,
  disabledTooltip,
}: PartialBy<ToolbarGroupProps, 'groupItems'>) {
  const isItemActive = isActive && !disabled

  if (!!groupItems?.length) {
    return (
      <ToolbarGroup
        groupTitle={groupTitle}
        groupItems={groupItems}
        defaultItem={defaultItem}
        disabled={disabled}
        isActive={isItemActive}
        onChange={onChange}
        disabledTooltip={disabledTooltip}
      />
    )
  }

  return (
    <ToolbarButton
      data-testid={`toolbar-item-${defaultItem.id}`}
      item={defaultItem}
      active={isItemActive}
      isInAction={isInAction}
      disabled={disabled}
      disabledTooltip={disabledTooltip}
      onClick={() => {
        onChange(defaultItem.id)
      }}
    />
  )
}
